var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sub.length > 0)?_c('h1',{staticClass:"sub"},[_vm._v(" "+_vm._s(_vm.sub)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }